module.exports = __webpack_public_path__ + "img/festningen.9f24e2d4.jpg";